export const timezoneItemTempl = (title: string) => {
  return `<div class="timezone-info">
            <div class="timezone-title">
              <h1 class="timezone-name">${ title || '' }</h1>
            </div>
            <div class="timezone-date"></div>
          </div>
          <div class="timezone-time"></div>`;
};

export const timezoneItemDiff = (diffTime: number) => {
  if(!diffTime) {
    return '';
  }
  
  const sign = diffTime > 0 ? '+' : '-';
  const absDiffTime = Math.abs(diffTime);
  return `<div class="timezone-diff">${`${sign}${absDiffTime}hr`}</div>`;
};

export const timezoneCurrent = () => {
  return `<div class="timezone-current no-dropdown"></div>`;
};

export const timezoneDropdown = () => {
  return `<div class="timezone-dropdown"></div>`;
};

export const timezoneCurrentTime = (hours: number, minutes: number, dayPeriod: string) => {
  const zeroPadHours = `${hours}`?.padStart(2, '0');
  const zeroPadMinutes = `${minutes}`?.padStart(2, '0');
  const periodIcon = dayPeriod === 'PM' ? '<span class="icon-night">(밤 아이콘)</span>' : '<span class="icon-morning">(낮 아이콘)</span>';
  const timeText = `<span class="time-text">${zeroPadHours}:${zeroPadMinutes} ${dayPeriod}</span>`;
  return `${periodIcon} ${timeText}`;
};

export const timezoneDate = (year: number, month: string | null, date: number | null) => {
  return `${month} ${date}, ${year}`;
};

export const timezoneLayer = () => {
  return `<div class="ncui-timezone-layer">
    <div class="ncui-timezone-layer-inner">
      <div class="ncui-timezone-content-wrap"></div>
      <div class="ncui-timezone-btn-wrap"></div>
    </div>
  </div>`;
};
